import React, { useState, useEffect } from 'react';

/**
 * Componente para mostrar tipologías de Sperant API v3
 */
const SperantProjectsList = ({ sperantId, onDataReceived }) => {
  const [types, setTypes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const fetchSperantTypes = async () => {
      setLoading(true);
      setError(null);

      try {
        // Usar el endpoint de WordPress que actúa como proxy para tipologías
        const proxyUrl = `${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/sperant/v1/projects/${sperantId}/types`;

        const response = await fetch(proxyUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Error HTTP ${response.status}: ${response.statusText}\nDetalles: ${errorText}`);
        }

        const result = await response.json();

        // Usar result.data si existe
        if (result.data) {
          setTypes(result.data);
          setMeta(result.meta || null);

          // Notificar al componente padre con los datos recibidos
          if (onDataReceived && typeof onDataReceived === 'function') {
            onDataReceived(result.data);
          }
        } else {
          throw new Error('No se encontró data en la respuesta');
        }

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (sperantId) {
      fetchSperantTypes();
    }
  }, [sperantId]);

  if (loading) {
    return (
      <div style={{
        padding: '20px',
        margin: '20px 0',
        border: '2px solid #ffd700',
        borderRadius: '8px',
        backgroundColor: '#fffbf0',
        fontFamily: 'Arial, sans-serif',
        display: 'none',
      }}>
        <h3 style={{ color: '#b8860b', margin: '0 0 10px 0' }}>
          🔄 Cargando Tipologías de Sperant v3
        </h3>
        <p>Conectando a través del proxy de WordPress...</p>
        <p>Proxy: /wp-json/sperant/v1/projects/{sperantId}/types → https://api.sperant.com/v3/projects/{sperantId}/types</p>
        <p>Sperant ID actual: {sperantId}</p>
        <p>⚙️ El endpoint obtiene automáticamente todas las páginas y filtra por units_available &gt; 0</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        padding: '20px',
        margin: '20px 0',
        border: '2px solid #dc3545',
        borderRadius: '8px',
        backgroundColor: '#f8d7da',
        fontFamily: 'Arial, sans-serif',
        display: 'none',
      }}>
        <h3 style={{ color: '#721c24', margin: '0 0 10px 0' }}>
          ❌ Error al conectar con Sperant v3
        </h3>
        <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
          <p><strong>Error:</strong> {error}</p>
          <p><strong>Proxy URL:</strong> /wp-json/sperant/v1/projects/{sperantId}/types</p>
          <p><strong>Target:</strong> https://api.sperant.com/v3/projects/{sperantId}/types</p>
          <p><strong>Sperant ID:</strong> {sperantId}</p>
          <p><strong>Método:</strong> GET a través de proxy local</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      padding: '20px',
      margin: '20px 0',
      border: '2px solid #28a745',
      borderRadius: '8px',
      backgroundColor: '#d4edda',
      fontFamily: 'Arial, sans-serif',
      display: 'none',
    }}>
      <h3 style={{ color: '#155724', margin: '0 0 15px 0' }}>
        ✅ Tipologías de Sperant v3 - Conexión Exitosa
      </h3>

      <div style={{
        marginBottom: '15px',
        padding: '10px',
        backgroundColor: '#b3d4fc',
        borderRadius: '4px',
        border: '1px solid #0056b3'
      }}>
        <p style={{ margin: '5px 0' }}><strong>Sperant ID del proyecto:</strong> {sperantId}</p>
        <p style={{ margin: '5px 0' }}><strong>Total de tipologías obtenidas:</strong> {Array.isArray(types) ? types.length : 'N/A'}</p>
        <p style={{ margin: '5px 0' }}><strong>Fecha consulta:</strong> {new Date().toLocaleString()}</p>
        {meta && (
          <>
            <p style={{ margin: '5px 0' }}><strong>🔄 Páginas consultadas:</strong> {meta.total_paginas_consultadas || meta.total_pages_fetched || 'N/A'}</p>
            <p style={{ margin: '5px 0' }}><strong>📊 Total tipologías:</strong> {meta.total_tipologias || meta.total_items || 'N/A'}</p>
          </>
        )}
      </div>

      <h4 style={{ color: '#155724', margin: '15px 0 10px 0' }}>
        📋 JSON obtenido de Sperant v3:
      </h4>

      <div style={{
        backgroundColor: '#2d3748',
        color: '#e2e8f0',
        padding: '15px',
        borderRadius: '4px',
        overflow: 'auto',
        maxHeight: '500px',
        fontSize: '12px',
        fontFamily: 'Consolas, Monaco, monospace',
        lineHeight: '1.4',
        border: '1px solid #4a5568'
      }}>
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
          {JSON.stringify(types, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default SperantProjectsList;
